import Axios from "axios";
import { login } from "../../actions/auth";

export const getHttpMethods = (dispatch, state) => {
  var http = {};
  dispatch(login());
  Axios.defaults.headers.common["Authorization"] = state().auth.token;
  Axios.defaults.headers.common["Pragma"] = "no-cache";
  http.get = function (uri, input) {
    return Axios.get(uri, input);
  };

  http.post = function (uri, input) {
    return new Promise(function (resolve, reject) {
      try {
        Axios.post(uri, input)
          .then((response) => {
            resolve(response);
          })
          .catch((error) => {
            console.log(error);
            reject(error);
          });
      } catch (error) {
        reject(error);
      }
    });
  };

  http.delete = function (uri, input) {
    return new Promise(function (resolve, reject) {
      try {
        Axios.delete(uri, { params: input })
          .then((response) => {
            resolve(response);
          })
          .catch((error) => {
            console.log(error);
            reject(error);
          });
      } catch (error) {
        reject(error);
      }
    });
  };

  http.all = function (iterable) {
    return Axios.all(iterable);
  };

  http.spread = function (callback) {
    return Axios.spread(callback);
  };

  return http;
};

export const respond = (actionName, error, dispatch, actionType) => {
  let error_response = {};

  if (error.response && error.response.status && error.response.data) {
    error_response = {
      status: error.response.status,
      code: error.response.data,
      actionName: actionName,
      errorPath: error.response.status + "_" + error.response.data.message,
    };
  } else {
    error_response = {
      message: error.message,
      errorPath: "GENERIC_ERROR",
    };
  }
  dispatch({
    type: actionType ? actionType : "SET_ERROR",
    data: { error_obj: error_response },
  });
};
